import { useIonViewWillEnter } from '@ionic/react';
import { useAtom } from 'jotai';

import {
    jobDetailsLoadableAtom,
    photosUploadedAtoms,
} from '../../store/Atoms';
import { ODOO_INST_TYPE } from '../constants';

export default function usePhotosUploaded(): boolean {
    const [photosUploaded, setPhotosUploaded] = useAtom(photosUploadedAtoms);
    const [value] = useAtom(jobDetailsLoadableAtom);
    const photosUploadedValues = Object.values(photosUploaded);
    const isRepair =
        value.state === 'hasData' &&
        value.data.typeInstallation === ODOO_INST_TYPE.REPAIR;

    useIonViewWillEnter(() => {
        // Reset state when the component mounts
        setPhotosUploaded({});
    });

    // In repairs we need to check which photos are mandatory
    if (isRepair) {
        return !!photosUploadedValues
            .filter((state) => state.mandatory)
            .every((state) => state && state.uploaded);
    }

    // In new interventions all photos are mandatory. No need to check the mandatory ones
    return !!photosUploadedValues.every((state) => state && state.uploaded);
}
